import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _Icon;
import { forwardRef, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { FALLBACK_ICON, SVG_LIB_BASE_PATH } from '../Icon/icon-consts';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders a country svg image icon from the Zenith SVG library.
 */
export var CountryIcon = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    src = _ref.src,
    sx = _ref.sx;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var alt = id.split('-').join(' ');
  var svgPath = "".concat(SVG_LIB_BASE_PATH, "/misc/country/").concat(id, ".svg");
  var srcToRender = function () {
    if (error) return '';
    if (src) return src;
    return svgPath;
  }();
  var handleImgError = function handleImgError() {
    if (!error) {
      setError(true);
    }
  };
  useEffect(function () {
    setError(false);
  }, [id]);
  return /*#__PURE__*/_jsx(Box, {
    "data-name": "Icon-".concat(id),
    "data-testid": "Icon-".concat(id),
    ref: ref,
    sx: _extends({
      alignItems: 'center',
      display: 'flex',
      height: size,
      justifyContent: 'center',
      width: size
    }, sx),
    children: error ? _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
      iconId: FALLBACK_ICON
    })) : /*#__PURE__*/_jsx("img", {
      alt: alt,
      height: size,
      onError: handleImgError,
      src: srcToRender,
      width: size
    })
  });
});